import { css } from '@/styled-system/css';

export const comboboxInputStyles = css.raw({
  color: 'Combobox.Input.text.populated',
  _placeholder: {
    color: 'Combobox.Input.text.placeholder',
  },
  textStyle: 'body',
  flexGrow: 1,
  width: 0,
  minWidth: 0,
  transition: 'background-color calc(infinity * 1s) step-end',
});
